import { KeysOfType } from './array-to-record';

export function replaceInArrayByProperty<T>(
  array: T[],
  key: KeysOfType<T, string | number>,
  value: T
): T[] {
  if (!array) {
    return [];
  }

  return array.map((i) => (i[key] === value[key] ? value : i));
}
